import React from 'react';

export type AvatarProps = {
  name?: string;
  size?: number;
  src?: string;
  accent?: string;
};

export function Avatar({
  name = '?',
  size = 36,
  src,
  accent = 'var(--accent)',
}: AvatarProps) {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover' }}
      />
    );
  }
  return (
    <div
      style={{
        width: size, height: size, borderRadius: '50%',
        background: `linear-gradient(135deg, ${accent}, color-mix(in oklab, ${accent} 70%, #fff))`,
        color: '#fff', fontWeight: 600, fontSize: size * 0.36,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}

export default Avatar;
